import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

const ChartStackedBar = ({ valueChart, chartColor, chartLabel, legend = true }) => {
    const chartData = valueChart;
    const options = {
        responsive: true,
        legend: {
            display: legend,
            position: "bottom",
            labels: {
                fontSize: 14,
                fontColor: "#6C757D",
                fontFamily: "Calibri",
            },
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    const labels = chartLabel;

    let data = {
        labels,
        datasets: [
            // {
            //     label: "test1",
            //     data: [1, 2, 3],
            //     backgroundColor: "#C4161C",
            // },
            // {
            //     label: "test2",
            //     data: [2, 3, 4],
            //     backgroundColor: "#1D3557",
            // },
            // {
            //     label: "test3",
            //     data: [3, 4, 5],
            //     backgroundColor: "#FB8500",
            // },
            {
                label: "test1",
                data: chartData,
                backgroundColor: chartColor,
            },
        ],
    };
    // console.log("====================================");
    // console.log(chartData);
    // console.log("====================================");
    return (
        <div>
            <Bar data={data} options={options} />
        </div>
    );
};

export default ChartStackedBar;
